var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{attrs:{"id":"download-app"}},[_c('NavigationHeader',{attrs:{"route":"/","navigationText":"Zum Dashboard","title":"Download App"}}),_c('AppDownload')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }